// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__srX0I","content":"LoadingScreen_content__zCabV","spinner":"LoadingScreen_spinner__y71XO","text":"LoadingScreen_text__IC9fk"};